import { jsx as _jsx } from "react/jsx-runtime";
import { useContext } from 'react';
import { useT, isObject } from '@progress-fe/core';
import { Box } from '@chakra-ui/react';
import { VirtualTable } from '../../tables';
import { DialogableContainer } from '../../containers';
import { TABLE_VARIANTS } from '../../tables/VirtualTable/VirtualTable.enum';
import { JsFormConfigContext } from '../../../contexts';
import { JsFieldInspector } from '../../jsFormBase';
const DEFAULT_TABLE_HEIGHT = 300;
/**
 * Component renders "/schemas/jsf-table" field of JsonSchema.
 * @param props : field props come from JsonSchema.
 * Value of props.formData is TTableFormData.
 */
export const TableJsField = (props) => {
    const { isInspector } = useContext(JsFormConfigContext) ?? {};
    const { t } = useT();
    const config = props.formData?.fieldConfig;
    const values = props.formData?.fieldValues;
    const columns = config?.columns ?? [];
    const rows = (values ?? []).map((rowValues, idx) => ({
        key: idx.toString(),
        values: rowValues
    }));
    const handleValueChange = (rowId, colomnId, newValue) => {
        if (!values) {
            return;
        }
        const newTableData = structuredClone(values);
        const curVal = newTableData[rowId][colomnId];
        newTableData[rowId][colomnId] = isObject(curVal) ? { ...curVal, value: newValue } : newValue;
        props.onChange({
            ...props.formData,
            fieldValues: newTableData
        });
    };
    return (_jsx(JsFieldInspector, { isActive: isInspector, fieldCode: props.name, fieldType: props.uiSchema?.['ui:field']?.toString() ?? '', valueType: ['object'], children: _jsx(Box, { pb: '2px', children: _jsx(DialogableContainer, { "data-testid": "TableJsField-test", "data-name": props.name, title: props.schema.title ?? '', dialogMinWidth: "70%", floatMinWidth: "30%", children: _jsx(VirtualTable, { variant: config?.isFixedColumn ? TABLE_VARIANTS.FIRST_COLOMN_FIXED : undefined, columns: columns, rows: rows, noItemsTitle: t('common.noData'), isTableShownWhenEmpty: true, tableSx: {
                        height: config?.height ?? DEFAULT_TABLE_HEIGHT
                    }, onValueChange: handleValueChange }) }) }) }));
};
//# sourceMappingURL=TableJsField.js.map